"use strict";
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(exports, "__esModule", { value: true });
exports.CognitoUserPoolsTokenProvider = void 0;
const core_1 = require("@aws-amplify/core");
const refreshAuthTokens_1 = require("../utils/refreshAuthTokens");
const TokenStore_1 = require("./TokenStore");
const TokenOrchestrator_1 = require("./TokenOrchestrator");
class CognitoUserPoolsTokenProvider {
    constructor() {
        this.authTokenStore = new TokenStore_1.DefaultTokenStore();
        this.authTokenStore.setKeyValueStorage(core_1.defaultStorage);
        this.tokenOrchestrator = new TokenOrchestrator_1.TokenOrchestrator();
        this.tokenOrchestrator.setAuthTokenStore(this.authTokenStore);
        this.tokenOrchestrator.setTokenRefresher(refreshAuthTokens_1.refreshAuthTokens);
    }
    getTokens({ forceRefresh } = { forceRefresh: false }) {
        return this.tokenOrchestrator.getTokens({ forceRefresh });
    }
    setKeyValueStorage(keyValueStorage) {
        this.authTokenStore.setKeyValueStorage(keyValueStorage);
    }
    setAuthConfig(authConfig) {
        this.authTokenStore.setAuthConfig(authConfig);
        this.tokenOrchestrator.setAuthConfig(authConfig);
    }
}
exports.CognitoUserPoolsTokenProvider = CognitoUserPoolsTokenProvider;
